import { isValidElement } from "react";
export default ((element, Component) => /*#__PURE__*/isValidElement(element) && (typeof Component === "string" ? element.type.typeRef === Component : element.type === Component));